import React from 'react';
import styles from '../style.module.scss';
import { EyeIcon } from 'assets';
import Heading from 'shared/components/common/heading/Heading';
import { useNavigate } from 'react-router-dom';
import { routeConstant } from 'shared/routes/RouteConstant';
import { toastMessage } from 'shared/components/toast/Toast';
import moment from 'moment';

export default function CompleteTask({ tasklist, opentaskview, heading, handleAssign }) {
    const navigate = useNavigate();

    const navigateToPath = (taskInprogress) => {
        navigate(routeConstant.user.wopt.path, { state: { taskInprogress } });
    };
    return (
        <div className={styles.Taskitem}>
            {heading && (
                <div className={styles.Header}>
                    <Heading heading={heading} headingStyle={styles.Heading} />
                </div>
            )}
            <div className={styles.Listing}>
                {tasklist.map((task, taskInx) => {
                    const sku = task?.task_inventory?.sku || task?.task_sku || 'N/A';
                    const brand = task?.task_brand?.name || '';
                    const ccpb = task?.task_compatiableBrand?.name || '';
                    const subcat = task?.task_subcategory?.name || '';
                    const cat = task?.task_category?.name || '';
                    const color = task?.task_inventory?.color || task?.task_color || task?.color || '';
                    const model = task?.task_product?.name || task?.task_product?.model || (task?.name && task?.name !== 'Rough Listing Item' ? task?.name : '') || '';
                    const titleDetails = `${ccpb} ${model} ${cat} ${subcat} ${color}`.replace(/\s+/g, ' ').trim();

                    return (
                        <div className={styles.ListingFlex} key={taskInx}>
                            <div className={styles.CardHeader}>
                                <div
                                    className={styles.SKU}
                                    title="Click to copy SKU"
                                    onClick={() => {
                                        if (sku !== 'N/A') {
                                            navigator.clipboard.writeText(sku);
                                            toastMessage('success', 'SKU Copied!');
                                        }
                                    }}
                                >
                                    {sku}
                                </div>
                                <div className={styles.DateAndPriority}>
                                    <span>Completed Date: {moment(task?.updated_at).format('DD MMM, YYYY.')}</span>
                                    {task?.priority && (
                                        <span className={task.priority == 'HIGH' ? styles.periorityON : task.priority == 'MIDDLE' ? styles.periorityORANGE : styles.periority}></span>
                                    )}
                                </div>
                            </div>
                            <div className={styles.CardBody}>
                                <p
                                    className={styles.TaskTitle}
                                    title="Click to copy Title Details"
                                    onClick={() => {
                                        if (titleDetails) {
                                            navigator.clipboard.writeText(titleDetails);
                                            toastMessage('success', 'Details Copied!');
                                        }
                                    }}
                                >
                                    {titleDetails}
                                </p>
                            </div>
                            <div className={styles.CardFooter}>
                                <div className={styles.Brand}>{task?.task_brand?.name || 'N/A'}</div>
                                <div className={styles.ActionButtons}>
                                    <EyeIcon
                                        onClick={() => {
                                            navigateToPath(task);
                                        }}
                                    />
                                    <span className={styles.Score}>Score: {task.task_point || 0}</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
